import { render, staticRenderFns } from "./addAbnormal.vue?vue&type=template&id=3821d4d3&scoped=true"
import script from "./addAbnormal.vue?vue&type=script&lang=js"
export * from "./addAbnormal.vue?vue&type=script&lang=js"
import style0 from "./addAbnormal.vue?vue&type=style&index=0&id=3821d4d3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821d4d3",
  null
  
)

export default component.exports